'use client';

import { useCallback } from 'react';

import { useFlagDetails } from '@/_hooks/useFlagDetails';
import { captureSentryError, FetcherError, SentryContext } from '@/_lib/sentry';

interface CaptureErrorReturnProps {
  captureError: (error: string | Error, context: SentryContext) => void;
}

export const useCaptureError = (): CaptureErrorReturnProps => {
  const { enabledFlags } = useFlagDetails();

  const handleCaptureError = useCallback(
    (error: string | Error | FetcherError, context: SentryContext) => {
      // Send enabled flags to Sentry
      const sentryContext = { ...context, contexts: { ...context.contexts, enabledFlags } };

      captureSentryError(error, sentryContext);
    },
    [enabledFlags]
  );

  return {
    captureError: handleCaptureError
  };
};
